@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.wrapper {
  display: flex;
  align-items: center;
  width: 100%;

  label {
    margin-right: 10px;
    font-size: 14px;
    font-weight: 600;
  }

  input {
    font-size: 18px;
    height: 50px;

    &::placeholder {
      color: var(--grey-500);
    }
  }
}

.input {
  width: 100%;
  border-radius: 4px 0 0 4px;

  &.active {
    border: 1px solid @scan-page--verify-header--active--border-color;
    box-shadow: 0 0 5px @scan-page--verify-header--active--box-shadow-color;
  }
}

.submit-button {
  min-width: 170px;
  border-radius: 0 4px 4px 0;
  height: 50px;
  font-size: 18px;

  &.active {
    border: 1px solid @scan-page--verify-header--active--border-color;
    box-shadow: 0 0 5px @scan-page--verify-header--active--box-shadow-color;
  }
}
